import axiosClient from "./axiosClients";

import queryString from "query-string";

const uri = "/products";

class ProductApi {
  getAll = () => {
    return axiosClient.get(uri);
  };

  paginate = (
    size = 0,
    index = 1,
    valueSearch = "",
    keySort = "",
    idCategory = "",
    idSale = ""
  ) => {
    if (valueSearch === "all") {
      valueSearch = "";
    }

    const params = queryString.stringify({
      size,
      index,
      valueSearch,
      keySort,
      idCategory,
      idSale,
    });
    const url = `${uri}/pagination?${params}`;
    return axiosClient.get(url);
  };

  getDetail = (id) => {
    const url = `${uri}/${id}`;
    return axiosClient.get(url);
  };

  getProductRecommends = (idCategory, count) => {
    const params = queryString.stringify({
      idCategory,
      count,
    });
    const url = `${uri}/recommend?${params}`;
    return axiosClient.get(url);
  };

  getProductNews = (count) => {
    const params = queryString.stringify({
      count,
    });
    const url = `${uri}/new?${params}`;
    return axiosClient.get(url);
  };

  delete = (id) => {
    const url = `${uri}/${id}`;
    return axiosClient.delete(url);
  };

  create = (data) => {
    return axiosClient.post(uri, data);
  };

  upToPromotion = (idProducts, idPromotion) => {
    const url = `${uri}/promotion`;
    const data = {
      idProducts,
      idPromotion,
    };

    return axiosClient.put(url, data);
  };
}
const productApi = new ProductApi();
export default productApi;
